module.exports = __webpack_public_path__ + "media/images/star-c7d878b585894d7fb73563958af6cc2a.svg";